'use strict';

var style = require('./style');

module.exports = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/font-weight.js
// module id = 1056
// module chunks = 168707334958949